import React, { useContext, useState, useEffect } from 'react';
import context from '../../context';
import styled from 'styled-components';
import { gsap } from 'gsap';
import { Container } from 'react-bootstrap';
import { Button } from '../../styled-components';
import "./hero.css";
import { DownOutlined, WhatsAppOutlined } from '@ant-design/icons';
import Link from '../link';
import { Section } from '../../styled-components';
import FormProperty from '../forms/properties';
import FormCode from '../forms/code';
import { Agro } from '../../icons';
import { Input } from '../inputs';

const MainCont = styled(Section)`
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;
  overflow: hidden;
  margin-bottom: 2rem;
`;

const VideoOverLay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;  
  top: 0;
  left: 0;
  background-image: linear-gradient(rgba(0, 0, 0, .5), rgba(0, 0, 0, .5));
  z-index: 1;
`;

const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
`;

const TitleCont = styled.div`
  position: relative;
  z-index: 2;
  @media(min-width: 768px){
    max-width: 60%;
  }  
`;

const Title = styled.h1`
  font-size: 2rem;
  color: #fff;
  text-align: left;
`;

const ButtonWrapper = styled.div`
  margin-top: 2rem;
  display: flex;
  justify-content: left;
`;

const ButtonCustom = styled.a`
  border-radius: 4px;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.theme.primaryColor};
  color: #fff !important; /* ← Aquí aseguramos el blanco */
  border: none;
  cursor: pointer;
  text-decoration: none !important;
  transition: all 0.3s ease;
  gap: 0.75rem;

  &:hover {
    filter: brightness(1.1);
    color: #fff !important; /* ← También en hover */
  }

  &:focus {
    outline: none;
    color: #fff !important; /* ← También en focus */
  }

  .icon {
    font-size: 1.6rem;
    font-weight: bold;
    display: flex;
    align-items: center;
    color: #fff !important; /* ← Color blanco para el ícono también */
  }
`;
const SubTitle = styled.p`
  font-size: 1.8rem;
`;

const InputCont = styled.div`
  display: flex;
  flex-direction: column;
  @media(min-width: 768px){
    max-width: 80%;
    flex-direction: row;
  }  
`;

const InputCustom = styled(Input)`
  border-radius: 0px;
`;

const SearchOptionCont = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0;
`;

const SearchOption = styled.button`
  background: transparent;
  width: 100%;
  padding: 1rem 0;
  color: ${props => props.active ? "rgba(255, 255, 255, 1)" : "rgba(255, 255, 255, .6)" };
  position: relative;
  border: none;
  font-weight: bold;
  display: flex;
  justify-content: center;
  transition: 250ms ease;
  @media(min-width: 768px){
    width: 25%;
  }
`;

const ButtonLine = styled.div`
  position: absolute;
  bottom: .5rem;
  transition: 250ms ease;
  width: ${props => props.active ? "50%" : "0"};
  height: 3px;
  background-color: ${props => props.active ? props.theme.primaryColor : "transparent"};
`;

const DownLink = styled.a`
  text-decoration: none;
  color: #fff !important;
  background-color: ${props => props.theme.primaryColor};
  transition: 250ms ease;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  bottom: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover{
    filter: brightness(1.1);
  }
`;

export default () => {
  const state = useContext(context);
  const [byCode, setByCode] = useState(false);

  useEffect(() => {
    const tl = gsap.timeline();
    tl.from("#title", { opacity: 0, y: 10, duration: 1.5, ease: "back.out(1.7)" })
      .from("#search", { opacity: 0, y: 10, duration: 1, ease: "back.out(1.7)" }, "-=1")
      .from("#formSearch", { opacity: 0, y: 10, duration: 1.5, ease: "back.out(1.7)" }, "-=.5")
      .from("#downButton", { opacity: 0, y: 10, duration: 1.5, ease: "back.out(1.7)" }, "-=.5")
      .from("#downButton", { y: 5, repeat: -1, duration: 1.5, yoyo: true });

    return () => {
      tl.kill();
    }
  }, []);

  return (
    <MainCont>
      <Video
        src={require('../../videos/video.mp4')}
        autoPlay
        loop
        muted
        playsInline
        poster={require('../../videos/video.webp')}
      />
      <VideoOverLay />

      <Container>
        <TitleCont>
          <Title id="title">
            LOS BIENES RAICES SON NUESTRO UNIVERSO
          </Title>
          <SubTitle>
            Somos gestión inmobiliaria, inversión y tecnología
          </SubTitle>

          <ButtonWrapper id="formSearch">
            <ButtonCustom
              href="https://api.whatsapp.com/send?phone=56933880703&text=Hola,%20me%20interesa%20saber%20más%20sobre%20los%20servicios%20de%20Galacticas."
              target="_blank"
              rel="noopener noreferrer"
              title="Enviar WhatsApp"
            >
              <span className="icon"><WhatsAppOutlined /></span>
              CONTÁCTANOS
            </ButtonCustom>
          </ButtonWrapper>
        </TitleCont>
      </Container>

      
    </MainCont>
  );
};